import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "exam exam-detail" }
const _hoisted_2 = {
  key: 0,
  class: "exam-detail__inner"
}
const _hoisted_3 = { class: "exam-detail__head" }
const _hoisted_4 = { class: "exam-detail__title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  class: "exam-detail__facts",
  "aria-label": "テストの概要"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "exam-detail__status-main" }
const _hoisted_12 = {
  key: 0,
  class: "exam-detail__status-note"
}
const _hoisted_13 = { class: "exam-detail__actions" }
const _hoisted_14 = {
  key: 0,
  class: "exam-detail__section"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "exam-detail__section"
}
const _hoisted_17 = { class: "d-flex" }
const _hoisted_18 = { class: "text-h3" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "text-h4" }
const _hoisted_21 = {
  key: 3,
  class: "exam-detail__section exam-detail__cohort",
  "aria-label": "みんなの結果"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 4,
  class: "exam-detail__section"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "exam-detail__course-text" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 5,
  class: "exam-detail__section exam-detail__author"
}

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ROUTER_NAME } from '../../router'
import { checkMobile } from '../../utils/utils'
import ExamButton from '../organisms/ExamButton.vue'
import { format } from 'date-fns'
import { headerState } from '../../stores/header'
import { userState } from '../../stores/user'
import Exam from '../../models/exam'
import api from '../../../api/v2/api'
import { snackBarState } from '../../stores/snackbar'

const COHORT_MIN_USERS = 5

// 自分の受験（APIは本人の分だけを新しい順に返す）

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamDetail',
  setup(__props) {

const RobotImg = require("../../../../images/robot.png").default || require("../../../../images/robot.png")

const route = useRoute()
const router = useRouter()

const isMobile = ref(false)
const exam = ref<Exam | null>(null)
const skills = ref<any[]>([])

const headers = [
  {
    text: 'Skill',
    value: 'skill',
    sortable: false
  },
  {
    text: 'Skill Items',
    value: 'skillItems',
    sortable: false
  }
]

const user = computed(() => userState.user)

// みんなの結果を出す最少の人数（これより少ないと出さない）
const myAttempts = computed(() => (exam.value?.userExams ?? []).filter(userExam => !user.value || userExam.userId == user.value.id))
const finishedAttempts = computed(() => myAttempts.value.filter(userExam => userExam.finishedAt))
const showScores = computed(() => !!exam.value && !exam.value.hideResult)
const percent = (value: number | null | undefined) => `${Math.round(Number(value ?? 0))}点`

const myStatus = computed(() => {
  const latest = myAttempts.value[0]
  if (!latest) return { key: 'new', title: 'まだ受けていません', note: '' }
  if (!latest.finishedAt) return { key: 'doing', title: '受けている途中です', note: '続きから再開できます' }
  const count = finishedAttempts.value.length
  const times = count > 1 ? `これまで${count}回` : ''
  if (!showScores.value) return { key: 'done', title: '提出済みです', note: times }
  if (!latest.marked) return { key: 'done', title: '提出済み（採点待ち）', note: times }
  const best = Math.max(...finishedAttempts.value.filter(userExam => userExam.marked).map(userExam => Number(userExam.average ?? 0)))
  const note = [times, count > 1 ? `最高 ${percent(best)}` : ''].filter(Boolean).join('・')
  if (!exam.value?.passScore) return { key: 'done', title: `前回 ${percent(latest.average)}`, note }
  return latest.passed
    ? { key: 'passed', title: `前回 ${percent(latest.average)}・合格`, note }
    : { key: 'retry', title: `前回 ${percent(latest.average)}・合格まであと${Math.max(1, Math.ceil(exam.value.passScore - Number(latest.average ?? 0)))}点`, note }
})

const showCohort = computed(() => !!exam.value && !exam.value.isRecommendationTest && showScores.value && exam.value.usersCount >= COHORT_MIN_USERS)
// マイテストの「今までのテスト結果」（再テストの回ごとの結果と、再テストのメニュー）を開く
const openHistories = () => {
  if (!exam.value) return
  router.push({ name: ROUTER_NAME.MY_EXAM_LIST, query: { exam_id: String(exam.value.id) } })
}

const breadcrumbItems = computed(() => {
  if (route.params.userGoalId) {
    return [
      {
        text: 'ゴール一覧',
        disabled: false,
        exact: true,
        to: `/classroom/user-goals`
      },
      {
        text: 'ゴール詳細',
        disabled: false,
        exact: true,
        to: `/classroom/user-goals/${route.params.userGoalId}`
      },
      {
        text: exam.value ? exam.value.name : '',
        disabled: true,
        exact: true,
      }
    ]
  }

  return [
    {
      text: 'テスト一覧',
      disabled: false,
      exact: true,
      to: '/classroom/exam-list'
    },
    {
      text: exam.value ? exam.value.name : '',
      disabled: true,
      exact: true,
    }
  ]
})

const dateFormat = (date: string) => {
  return format(date, 'YYYY/MM/DD')
}

onMounted(async () => {
  isMobile.value = checkMobile()
  exam.value = await snackBarState.runWithLoading(
    api.exam.showForSummary(parseInt(route.params.examId as string), {})
  )
  
  headerState.setTitle(exam.value.name)
  skills.value = exam.value.examSkills.map((examSkill: any) => {
    return {
      skill: examSkill.name,
      skillItems: examSkill.skillItems.map((item: any) => item.name)
    }
  })
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" テストの詳細（受ける前に見る画面）。上から：何のテストか → 自分の状況と次の一手 → 内容 → みんなの結果（人数が少ないときは出さない） "),
    _createElementVNode("div", _hoisted_1, [
      (exam.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_AppBreadcrumb, { items: breadcrumbItems.value }, null, 8 /* PROPS */, ["items"]),
            _createElementVNode("header", _hoisted_3, [
              (exam.value.hasImage && exam.value.image && exam.value.image.url)
                ? (_openBlock(), _createBlock(_component_v_img, {
                    key: 0,
                    src: exam.value.image.url,
                    class: "exam-detail__image",
                    cover: ""
                  }, null, 8 /* PROPS */, ["src"]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h1", null, _toDisplayString(exam.value.name), 1 /* TEXT */),
                (exam.value.description)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "exam-detail__lead",
                      innerHTML: exam.value.description
                    }, null, 8 /* PROPS */, _hoisted_5))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("ul", _hoisted_6, [
                  (exam.value.questionCount)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-format-list-numbered", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createTextVNode(_toDisplayString(exam.value.questionCount) + "問", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (exam.value.timeLimit)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-timer-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createTextVNode("制限時間 " + _toDisplayString(exam.value.timeLimit) + "分", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (exam.value.passScore)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-flag-checkered", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createTextVNode("合格 " + _toDisplayString(exam.value.passScore) + "点", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (exam.value.difficultRate)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-star-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createTextVNode("難易度 " + _toDisplayString(exam.value.difficultRate) + " / 5", 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _createCommentVNode(" 自分の状況と、次にやること（ボタンは1つを主役にする） "),
            _createElementVNode("section", {
              class: _normalizeClass(["exam-detail__status", `is-${myStatus.value.key}`]),
              "aria-label": "あなたの状況"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "exam-detail__status-label" }, "あなたの状況", -1 /* CACHED */)),
                _createElementVNode("strong", null, _toDisplayString(myStatus.value.title), 1 /* TEXT */),
                (myStatus.value.note)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(myStatus.value.note), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(ExamButton, {
                  exam: exam.value,
                  user: user.value
                }, null, 8 /* PROPS */, ["exam", "user"]),
                (finishedAttempts.value.length)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      variant: "outlined",
                      size: "large",
                      onClick: openHistories
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(exam.value.canRetest ? '今までの結果・再テスト' : '今までの結果'), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ])
            ], 2 /* CLASS */),
            (exam.value.body)
              ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("h2", null, "このテストについて", -1 /* CACHED */)),
                  _createElementVNode("div", {
                    innerHTML: exam.value.body
                  }, null, 8 /* PROPS */, _hoisted_15)
                ]))
              : _createCommentVNode("v-if", true),
            (skills.value.length > 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", null, "テストするスキル", -1 /* CACHED */)),
                  _createVNode(_component_v_data_table, {
                    headers: headers,
                    items: skills.value,
                    "hide-default-footer": ""
                  }, null, 8 /* PROPS */, ["items"])
                ]))
              : _createCommentVNode("v-if", true),
            (exam.value.price)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 2,
                  class: "purchase-card d-flex mb-5"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_v_col, { cols: "7" }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_18, _toDisplayString(exam.value.name), 1 /* TEXT */),
                          _createElementVNode("p", null, _toDisplayString(exam.value.description), 1 /* TEXT */),
                          _createVNode(ExamButton, {
                            exam: exam.value,
                            user: user.value
                          }, null, 8 /* PROPS */, ["exam", "user"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_col, {
                        cols: "5",
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(exam.value.price.toLocaleString()), 1 /* TEXT */),
                            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "ms-1 mt-3" }, "円（税別）", -1 /* CACHED */))
                          ])
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" みんなの結果：人数が少ないと平均が個人の点数に近くなり、意味も薄いので出さない "),
            (showCohort.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                  _cache[14] || (_cache[14] = _createElementVNode("h2", null, "みんなの結果", -1 /* CACHED */)),
                  _createElementVNode("dl", null, [
                    _createElementVNode("div", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("dt", null, "受験した人", -1 /* CACHED */)),
                      _createElementVNode("dd", null, [
                        _createTextVNode(_toDisplayString(exam.value.usersCount.toLocaleString()), 1 /* TEXT */),
                        _cache[8] || (_cache[8] = _createElementVNode("small", null, "人", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("dt", null, "平均", -1 /* CACHED */)),
                      _createElementVNode("dd", null, [
                        _createTextVNode(_toDisplayString(Math.round(exam.value.averageRate)), 1 /* TEXT */),
                        _cache[10] || (_cache[10] = _createElementVNode("small", null, "%", -1 /* CACHED */))
                      ])
                    ]),
                    (exam.value.passScore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[13] || (_cache[13] = _createElementVNode("dt", null, "合格した人", -1 /* CACHED */)),
                          _createElementVNode("dd", null, [
                            _createTextVNode(_toDisplayString(exam.value.passedCount.toLocaleString()), 1 /* TEXT */),
                            _cache[12] || (_cache[12] = _createElementVNode("small", null, "人", -1 /* CACHED */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (exam.value.courses.length > 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                  _cache[16] || (_cache[16] = _createElementVNode("h2", null, "関連コース", -1 /* CACHED */)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(exam.value.courses, (course) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: course.id,
                      type: "button",
                      class: "exam-detail__course",
                      onClick: ($event: any) => (_ctx.$router.push({ name: _unref(ROUTER_NAME).COURSE_DETAIL, params: { courseId: course.id } }))
                    }, [
                      (course.image && course.image.url)
                        ? (_openBlock(), _createBlock(_component_v_img, {
                            key: 0,
                            src: course.image.url,
                            class: "exam-detail__course-image",
                            cover: ""
                          }, null, 8 /* PROPS */, ["src"]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_25, [
                        _createElementVNode("b", null, _toDisplayString(course.name), 1 /* TEXT */),
                        (course.description)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: course.description
                            }, null, 8 /* PROPS */, _hoisted_26))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ], 8 /* PROPS */, _hoisted_24))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            (exam.value.isRecommendationTest || exam.value.director)
              ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                  (exam.value.isRecommendationTest)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_img, {
                          src: _unref(RobotImg),
                          class: "exam-detail__author-image"
                        }, null, 8 /* PROPS */, ["src"]),
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, [
                          _createElementVNode("small", null, "テスト製作者"),
                          _createElementVNode("b", null, "EdbaseAIBot"),
                          _createElementVNode("span", { class: "text-warning" }, "ロボットによる自動作成")
                        ], -1 /* CACHED */))
                      ], 64 /* STABLE_FRAGMENT */))
                    : (exam.value.director)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (exam.value.director.image && exam.value.director.image.url)
                            ? (_openBlock(), _createBlock(_component_v_img, {
                                key: 0,
                                src: exam.value.director.image.url,
                                class: "exam-detail__author-image",
                                cover: ""
                              }, null, 8 /* PROPS */, ["src"]))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("span", null, [
                            _cache[18] || (_cache[18] = _createElementVNode("small", null, "講師", -1 /* CACHED */)),
                            _createElementVNode("b", null, _toDisplayString(exam.value.director.name), 1 /* TEXT */)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}
}

})